import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "absolute top-1/2 left-[max(45rem,calc(50%+8rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl",
  "aria-hidden": "true"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Background',
  props: {
    backgroundColor: {},
    isWithEffect: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative isolate flex items-center gap-x-6 overflow-hidden px-6 py-2.5 sm:px-3.5",
    style: _normalizeStyle({ backgroundColor: _ctx.backgroundColor })
  }, [
    (_ctx.isWithEffect)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "aspect-[577/310] w-[36.0625rem] opacity-50",
              style: _normalizeStyle({
                        background: `linear-gradient(to right, ${_ctx.backgroundColor} 10%, white 70%, white)`,
                        clipPath:
                            'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
                    })
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "aspect-[577/310] w-[36.0625rem] opacity-50",
              style: _normalizeStyle({
                        background: `linear-gradient(to right, ${_ctx.backgroundColor} 10%, white 70%, white)`,
                        clipPath:
                            'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
                    })
            }, null, 4)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})